import React, { useEffect, useState } from 'react';
import { EmptyState } from '@/components/custom/empty-state';
import { Link } from 'react-router-dom';
import { StudyGuideLessonDataGrid } from './study-guide-lesson-data-grid';
import { StudyGuideLessonModal } from './study-guide-lesson-modal';
import { useClient } from 'jsonapi-react';
import { Button } from '@/components/ui/button';
import { GuideAboutCard, GuideAboutCardBody, GuideAboutCardFooter, GuideAboutCardHeader, GuideAboutCardTitle } from '@/components/custom/guide';
import { Dialog, DialogTrigger } from '@/components/ui/dialog';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { PlayfulCard } from '@/components/custom/playful-card';

export function StudyGuideLesson() {
  const [watchedData, setWatchedData] = useState([]);
  const playful = usePlayfulStudent();

  const client = useClient();

  const getWatchedData = async () => {
    const response = await client.fetch('study_plan_reports/watched_videos');
    return response.data;
  };

  useEffect(() => {
    getWatchedData().then(data => {
      if (data.watched_videos) setWatchedData(data.watched_videos);
    });
  }, []);

  const hasWatchedData = watchedData.length > 0;

  if (playful) {
    return (
      <PlayfulCard
        className="flex h-full flex-col gap-3 p-4"
        style={{ background: '#fff' }}
      >
        <p
          className="mb-0 text-sm font-extrabold"
          style={{ color: '#222731' }}
        >
          Aulas iniciadas
        </p>

        {!hasWatchedData && (
          <EmptyState
            type="data"
            title="Você ainda não iniciou nenhuma aula"
            text={
              <span>
                Inicie uma aula clicando <Link to="/curso">aqui</Link>
              </span>
            }
            variant="plain"
            className="m-auto"
          />
        )}

        {hasWatchedData && <StudyGuideLessonDataGrid data={watchedData.slice(0, 6)} />}

        {hasWatchedData && watchedData.length > 6 && (
          <Dialog>
            <DialogTrigger asChild>
              <button
                type="button"
                className="self-start text-sm font-bold"
                style={{ color: 'var(--color-secondary)' }}
              >
                Ver mais
              </button>
            </DialogTrigger>

            <StudyGuideLessonModal data={watchedData} />
          </Dialog>
        )}
      </PlayfulCard>
    );
  }

  return (
    <GuideAboutCard>
      <GuideAboutCardHeader>
        <GuideAboutCardTitle>Aulas iniciadas</GuideAboutCardTitle>
      </GuideAboutCardHeader>

      <GuideAboutCardBody isEmpty={!hasWatchedData}>
        {!hasWatchedData && (
          <EmptyState
            type="data"
            title="Você ainda não iniciou nenhuma aula"
            text={
              <span>
                Inicie uma aula clicando <Link to="/curso">aqui</Link>
              </span>
            }
            variant="plain"
            className="m-auto"
          />
        )}

        {hasWatchedData && <StudyGuideLessonDataGrid data={watchedData.slice(0, 6)} />}
      </GuideAboutCardBody>

      {hasWatchedData && watchedData.length > 6 && (
        <GuideAboutCardFooter>
          <Dialog>
            <DialogTrigger asChild>
              <Button variant="link">Ver mais</Button>
            </DialogTrigger>

            <StudyGuideLessonModal data={watchedData} />
          </Dialog>
        </GuideAboutCardFooter>
      )}
    </GuideAboutCard>
  );
}
